import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { type FC, Suspense, lazy } from "react";

const AutoLogoutPage = lazy(() => import("./AutoLogoutPage.tsx"));

const AutoLogoutPageLazy: FC = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <AutoLogoutPage />
    </Suspense>
  );
};

export default AutoLogoutPageLazy;
